module.exports = __webpack_public_path__ + "media/images/logos/elp-logo-color-5-21-3d60cb51d461b76d5587f924da286b2f.svg";